export var sessionStorageSetItem = function sessionStorageSetItem(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};
export var sessionStorageRemoveItem = function sessionStorageRemoveItem(key) {
  window.sessionStorage.removeItem(key);
};
export var sessionStorageGetItem = function sessionStorageGetItem(key) {
  return JSON.parse(window.sessionStorage.getItem(key));
};
//# sourceMappingURL=useSessionStorage.js.map